module.exports = __webpack_public_path__ + "static/media/kernelcon_hilton9.6b656e12.jpg";